import React from 'react';
import { FiUser, FiGlobe } from 'react-icons/fi';
import { CampoTexto } from './CamposFormulario';

/** Datos de contacto del usuario. Visible para admin y técnico. */
const FormularioInformacion = ({ usuarioData, form, errores, onCampo }) => {
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  return (
    <>
      <h4 className="perfil-form-seccion"><FiUser /> Datos personales</h4>

      <div className="perfil-form-campo">
        <label htmlFor="campo-usuario">Usuario</label>
        <span className="perfil-form-hint" id="campo-usuario-hint">
          Identificador de acceso. Solo modificable desde la base de datos.
        </span>
        <input
          id="campo-usuario"
          type="text"
          value={`@${usuarioData.usuario}`}
          aria-describedby="campo-usuario-hint"
          disabled
        />
      </div>

      <div className="perfil-form-grid">
        <CampoTexto
          id="campo-nombre"
          name="nombre"
          label="Nombre"
          autoComplete="given-name"
          value={form.nombre}
          onChange={cambiar}
          error={errores.nombre}
        />
        <CampoTexto
          id="campo-apellidos"
          name="apellidos"
          label="Apellidos"
          autoComplete="family-name"
          value={form.apellidos}
          onChange={cambiar}
          error={errores.apellidos}
        />
      </div>

      <div className="perfil-form-grid">
        <CampoTexto
          id="campo-email"
          name="email"
          label="Email"
          type="email"
          autoComplete="email"
          value={form.email}
          onChange={cambiar}
          error={errores.email}
        />
        <CampoTexto
          id="campo-telefono"
          name="telefono"
          label="Teléfono"
          type="tel"
          autoComplete="tel"
          value={form.telefono}
          onChange={cambiar}
          error={errores.telefono}
        />
      </div>

      <h4 className="perfil-form-seccion"><FiGlobe /> Sitios del cliente</h4>

      <CampoTexto
        id="campo-webs"
        name="webs_del_cliente"
        label="Webs asociadas"
        hint="Si son varias, sepáralas con comas."
        placeholder="ejemplo.com, tienda.ejemplo.com"
        value={form.webs_del_cliente}
        onChange={cambiar}
      />
    </>
  );
};

export default FormularioInformacion;
